module.exports = __webpack_public_path__ + "static/media/message-inbox-loyalty-promo.cad281a0.png";